import { Link } from "react-router"
import { ArrowUpRight } from "../layout"

export function OurWhy() {
  return (
    <section className="relative flex min-h-[491px] items-center overflow-hidden bg-forest-950 py-0 lg:h-[559px] lg:min-h-0">
      <img
        src="/images/home/hero-texture.png"
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-forest-950/95 via-forest-950/75 to-forest-700/45" />

      <div className="public-container relative max-w-[1080px] py-18 sm:py-20 lg:py-0">

        <div className="text-center">
          <span className="inline-flex rounded-full bg-forest-950/90 px-4 py-1.5 text-sm font-medium text-gold-500">
            Our Why
          </span>
        </div>

        <blockquote className="mt-8 font-display text-[26px] font-bold leading-[1.2] text-white sm:text-[40px] sm:leading-[1.15] lg:text-[48px]">
          &ldquo;The gap between a child&rsquo;s potential and a decent life shouldn&rsquo;t be school fees. So we close that gap — <span className="text-gold-500">one child, one term, one book at a time.</span>&rdquo;
        </blockquote>

        <Link to="/about" className=" mt-8 lg:mt-12 inline-flex items-center gap-3 rounded-full border border-white/70 px-5 py-2.5 text-base font-semibold text-white transition-colors hover:bg-white hover:text-forest-950">
          Read our story
          <span className="grid h-10 w-10 place-items-center rounded-full">
            <ArrowUpRight />
          </span>
        </Link>
      </div>
    </section>
  )
}
